import 'rc-tabs/assets/index.css';



// WEBPACK FOOTER //
// ./components/react-tabs/rc-tabs.page.js